import { render, staticRenderFns } from "./ZebraPreview.vue?vue&type=template&id=14db15cf&scoped=true"
import script from "./ZebraPreview.vue?vue&type=script&lang=js"
export * from "./ZebraPreview.vue?vue&type=script&lang=js"
import style0 from "./ZebraPreview.vue?vue&type=style&index=0&id=14db15cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14db15cf",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QCard,QCardSection,QForm,QBtn});
